import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks'; // ✅ New Footer Import
import BurgerHint from '../../components/layout/BurgerHint';   // ✅ Burger Tip!

const ContactPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>📬 Contact Us</h1>

        {/* 🍔 Burger Menu Tip */}
        <BurgerHint />
        
        <p>
          Need help? Have a suggestion? Just want to say hi? We’d love to hear from you.
        </p>

        <ul>
          <li>📧 <strong>Email:</strong>{' '}
            <a href="mailto:support@daisypal.com" className="hover:underline">
              support@daisypal.com
            </a>
          </li>
          <li>💡 <strong>Feedback:</strong> Tell us what dAIsy could do better. We’re building with care — and your input helps shape her.
          </li>
        </ul>

        <p className="mt-4">
          Thanks for being part of this journey. 🌼
        </p>

        {/* Footer */}
        <FooterLinks /> {/* ✅ Clean drop-in */}
      </div>
    </div>
  );
};

export default ContactPage;
